module.exports = __webpack_public_path__ + "img/fitt_dark.9d85da04.png";